import { render, staticRenderFns } from "./AssistantsAll.vue?vue&type=template&id=f5bb2cc0&scoped=true&"
import script from "./AssistantsAll.vue?vue&type=script&lang=js&"
export * from "./AssistantsAll.vue?vue&type=script&lang=js&"
import style0 from "./AssistantsAll.vue?vue&type=style&index=0&id=f5bb2cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bb2cc0",
  null
  
)

export default component.exports